export const ConvertToPersianNumber = (number) => {
    let Number = number.toString();
    let EnNumberWithSeprator = Number.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    let arryOfEnNumber = EnNumberWithSeprator.split('');
    let arryOfFaNumber = arryOfEnNumber.map(item =>{
        switch (item) {
            case "0":
                return '۰';
            case "1":
                return '۱';
            case "2":
                return '۲';
            case "3":
                return '۳';
            case "4":
                return '۴';
            case "5":
                return '۵';
            case "6":
                return '۶';
            case "7":
                return '۷';
            case "8":
                return '۸';
            case "9":
                return '۹';
            default:
                return ","
        }
    });
    return arryOfFaNumber.join('');
};

export const ConvertToENNumber = (number) => {
    let EnNum = number.split('');
    let newEn = EnNum.map(item => {
        switch (item) {
            case '۰':
                return 0;
            case '۱':
                return 1;
            case '۲':
                return 2;
            case '۳':
                return 3;
            case '۴':
                return 4;
            case '۵':
                return 5;
            case '۶':
                return 6;
            case '۷':
                return 7;
            case '۸':
                return 8;
            case '۹':
                return 9;
            default:
                return item
        }
    });
    return newEn.join('');};
export const AddIcon = (arr) => {
    return arr.map(item=>{
        switch (item.key) {
            case 'اینستاگرام':
                return {
                    key: item.key,
                    icon: 'instagram',
                    href: item.value ,
                    name: 'اینستاگرام'
                };
            case 'تلگرام' :
                return {
                    key: item.key,
                    icon: 'telegram',
                    href: item.value,
                    name: 'تلگرام'
                };
            case 'آپارات':
                return {
                    key: item.key,
                    icon: 'youtube-play',
                    href: item.value,
                    name: 'آپارات'
                };
            case 'تلگرام-ربات':
                return {
                    key: item.key,
                    icon: 'reddit-alien',
                    href: item.value,
                    name: 'تلگرام-ربات'
                };
            default :
                return null
        }
    })};

export const calculatePrice = (product) =>{
    if(product.install){
        if(product.type === 'vehicle'){
            if(product.productFor === 'inner'){
                if(parseInt(product.offer)) {
                    return (((product.inner_car_price - (product.inner_car_price * (parseInt(product.offer) / 100))).toFixed(0)) + product.install_price) * (product.quantity ? product.quantity : 1);
                }
                else {
                    return (product.inner_car_price + product.install_price) * (product.quantity ? product.quantity : 1)
                }
            } else { // FOR OUTER
                if(parseInt(product.offer)) {
                    return (((product.outer_car_price - (product.outer_car_price * (parseInt(product.offer) / 100))).toFixed(0)) + product.install_price) * (product.quantity ? product.quantity : 1);
                }
                return (product.outer_car_price + product.install_price) * (product.quantity ? product.quantity : 1)
            }
        } else { // NOT VEHICLE
            if(parseInt(product.offer)) {
                return  (parseInt(((product.inner_car_price - (product.inner_car_price * (parseInt(product.offer) / 100))).toFixed(0)))+ parseInt(product.install_price)) * (product.quantity ? product.quantity : 1)
            } else {
                return (product.inner_car_price + product.install_price) * (product.quantity ? product.quantity : 1)
            }
        }
    } else { //NOT INSTALL
        if(product.type === 'vehicle'){
            if(product.productFor === 'inner'){
                if(parseInt(product.offer)) {
                    return ((product.inner_car_price - (product.inner_car_price * (parseInt(product.offer) / 100))).toFixed(0)) * (product.quantity ? product.quantity : 1)
                }
                else {
                    return product.inner_car_price * product.quantity
                }
            } else { // FOR OUTER
                if(parseInt(product.offer)) {
                    return ((product.outer_car_price - (product.outer_car_price * (parseInt(product.offer) /100))).toFixed(0)) * (product.quantity ? product.quantity : 1)
                }
                return product.outer_car_price * product.quantity
            }
        } else { // NOT VEHICLE
            if(parseInt(product.offer)) {
                return ((product.inner_car_price - (product.inner_car_price * (parseInt(product.offer) /100))).toFixed(0)) * (product.quantity ? product.quantity : 1)
            } else {
                return product.inner_car_price * product.quantity
            }
        }
    }
};
/** SAMPEL OF DATA
Price: 19000
ProductProp: (17) [{…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}]
ProductSpecific: (34) [{…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}]
description: "<p><span style="text-align: justify;">ردياب زیتونیکس مدل ZX01 ساخت ایران، سامانه ايست بسيار کارا و فوق العاده که از دو بخش سخت افزاری و نرم افزاری تشکيل شده است.اين محصول در ابعاد کوچک طراحی شده و امکان رديابي هر نوع وسيله نقليه با تغذيه 6 تا 24 ولت مستقيم مانند آنچه در اکثر خودروهای سواری و سنگین و موتورسيکلت ها موجود است و یا استفاده شخصی بدین صورت که دستگاه دارای باتری پشتیبان میباشد و تا 12 ساعت موقعیت یابی بی وقفه در صورت قطع تغذیه را براي مالک آن فراهم می آورد.اين دستگاه دارای 2 آنتن GPS و GSM داخلی می باشد. دستگاه پس از دريافت مختصات جغرافيايی و مکان يابی خود، توسط آنتن GPS، اطلاعات محاسبه شده شامل موقعيت را با دقت بهتر از 5 متر، سرعت، جهت حرکت خودرو و اطلاعات تکميلی ديگر توسط سيمکارت داخلي به سيستم مرکزی فرستاده و مالک دستگاه می تواند با استفاده از کامپيوتر شخصی،موبايل و تبلت موقعيت مد نظر را به دقيق ترين شکل ممکن بصورت آنلاین توسط بستر اینترنت و یا بدون استفاده از اینترنت بصورت آفلاین و نرم افزار ویژه زیتونیکس روی نقشه مشاهده نمايد. و همچنين از گزارشات عملکرد دستگاه طی روز های گذشته مطلع شود.</span><br></p>"
exist: "1"
galery: (4) [{…}, {…}, {…}, {…}]
id: 9
image: "storage/uploadFiles/product/1615148518473-807376-IMG_5821-Recovered.jpg"
inner_car_price: 19000
install: true
install_price: 10000
name: "ردیاب خودرو مدل ZX01"
offer: "0"
outer_car_price: 10000
price: null
productFor: "outer"
quantity: 1
type: "vehicle"
 */